<template>
    <div class="rdvForm">
        <Header :code="code">{{this.projet.nom}}</Header>
        <v-form v-model="valid">
        <v-container>
            <v-row dense>
                <v-col cols="12">
                    <h4 v-if="mode == 'create'">Ajouter un rendez-vous</h4>
                    <h4 v-if="mode == 'edit'">Modifier un rendez-vous</h4>
                </v-col>
                <v-col cols="12" v-if="this.selectors">
                    <v-select
                        v-model="rdv.jour"
                        :items="dates"
                        label="Date"
                        hide-details
                        @change='reloadCreneaux'
                    ></v-select>
                </v-col>
                <v-col cols="12" v-if="this.selectors">
                    <v-select
                        v-model="rdv.creneau"
                        :items="creneaux" 
                        item-text="libelle"
                        item-value="debut_creneau"
                        label="Heure"
                        hide-details
                    ></v-select>
                </v-col>
                <v-col cols="12" v-if="!this.selectors">
                    <v-menu
                        ref="menuDate"
                        v-model="menu"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                    >
                        <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="rdv.jour"
                            label="Date du rendez-vous"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                        ></v-text-field>
                        </template>
                        <v-date-picker
                        v-model="testDate"
                        no-title
                        scrollable
                        @input="menu = false"
                        >
                        </v-date-picker>
                    </v-menu>
                </v-col>
                <v-col cols="12" v-if="!this.selectors">
                    <v-menu
                        ref="menu"
                        v-model="menu2"
                        :close-on-content-click="false"
                        :return-value.sync="rdv.creneau"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="290px"
                    >
                        <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="rdv.creneau"
                            label="Heure du rendez-vous"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                        ></v-text-field>
                        </template>
                        <v-time-picker
                        v-if="menu2"
                        format="24hr"
                        v-model="rdv.creneau"
                        full-width
                        @click:minute="$refs.menu.save(rdv.creneau)"
                        ></v-time-picker>
                    </v-menu>
                </v-col>
                <v-col cols="12">
                    <v-text-field
                        v-model="rdv.nb_pass"
                        hide-details
                        label="Nombre de personnes"
                        type="number"
                    ></v-text-field>
                </v-col>
                <v-col cols="12">
                    <v-textarea
                        name="input-7-1"
                        label="Commentaire"
                        v-model="rdv.commentaire"
                        hide-details 
                    ></v-textarea>
                </v-col>
                <v-col cols="12" class="text-center">
                    <v-btn-toggle    
                    v-model="rdv.est_physique"                          
                    tile
                    color="primary"
                    dense
                    mandatory
                    group
                    >
                        
                        <v-btn :value="false">
                            Rdv Visio
                        </v-btn>
                        <v-btn :value="true">
                            Rdv Physique
                        </v-btn>
                        <v-btn :value="null">
                            N/C
                        </v-btn>
                    </v-btn-toggle>
                </v-col>
                <v-col cols="12" class="btnGroup">
                    {{$t('messages.todo.venu')}}
                    <v-btn-toggle    
                    v-model="rdv.est_venu"                          
                    tile
                    color="primary"
                    dense
                    mandatory
                    group
                    >
                        <v-btn :value="null">
                            {{$t('messages.todo.nc')}}
                        </v-btn>
                        <v-btn :value="true">
                            {{$t('messages.todo.oui')}}
                        </v-btn>
                        <v-btn :value="false">
                            {{$t('messages.todo.non')}}
                        </v-btn>
                    </v-btn-toggle>
                </v-col>
                <v-col v-show="rdv.est_venu === true" cols="12" class="btnGroup">
                     {{$t('messages.todo.vendu')}}
                    <v-btn-toggle   
                    v-model="rdv.avec_vente"                           
                    tile
                    color="primary"
                    dense
                    mandatory
                    group
                    >
                        <v-btn :value="null">
                            {{$t('messages.todo.nc')}}
                        </v-btn>
                        <v-btn :value="true">
                            {{$t('messages.todo.oui')}}
                        </v-btn>
                        <v-btn :value="false">
                            {{$t('messages.todo.non')}}
                        </v-btn>
                    </v-btn-toggle>
                </v-col>
                <v-col v-show="rdv.avec_vente === true" cols="5" class="text-left question">
                    Type de vente
                    </v-col>
                    <v-col v-show="rdv.avec_vente === true" cols="7">
                        <v-btn-toggle   
                        v-model="rdv.VO_VN_VD"                           
                        tile
                        color="primary"
                        dense
                        mandatory
                        group
                        >
                            <v-btn :value="null"> 
                                NC
                            </v-btn>
                            <v-btn value="VN">
                                VN
                            </v-btn>
                            <v-btn value="VO">
                                VO
                            </v-btn>
                            <v-btn value="VD">
                                VD
                            </v-btn>
                        </v-btn-toggle>
                    </v-col>
                    <v-col v-show="rdv.VO_VN_VD !== null" cols="5" class="text-left question">
                    Financement
                    </v-col>
                    <v-col v-show="rdv.VO_VN_VD !== null" cols="7">
                        <v-btn-toggle   
                        v-model="rdv.financement"                           
                        tile
                        color="primary"
                        dense
                        mandatory
                        group
                        >
                            <v-btn :value="null">
                                {{$t('messages.todo.nc')}}
                            </v-btn>
                            <v-btn :value="true">
                                {{$t('messages.todo.oui')}}
                            </v-btn>
                            <v-btn :value="false">
                                {{$t('messages.todo.non')}}
                            </v-btn>
                        </v-btn-toggle>
                    </v-col>
                <v-col cols="12" v-if="mode == 'create'" class="btnGroup btns">
                    <v-btn dark depressed color="grey" @click="$router.push(-1)">Annuler</v-btn>
                    <v-btn depressed color="primary" @click="rdvModal = true">Enregistrer</v-btn>
                </v-col>
                <v-col cols="12" v-if="mode == 'edit'" class="btnGroup btns">
                    <v-btn dark depressed color="grey" @click="deleteConfirm = true">Supprimer</v-btn>
                    <v-btn depressed color="primary" @click="modifyRdv">Modifier</v-btn>
                </v-col>
            </v-row>
        </v-container>
        </v-form>
        <v-dialog
            v-model="rdvModal"
            persistent
            max-width="320"
        >
            <v-card>
                <v-card-title class="headline">
                Confirmer le rendez-vous ?
                </v-card-title>
                <v-card-text>Cette action enverra un message de confirmation à votre client</v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="primary"
                        text
                        @click="rdvModal = false"
                    >
                        Annuler
                    </v-btn>
                    <v-btn
                        color="primary"
                        text
                        @click="recordRdv"
                    >
                        Enregistrer
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
        v-model="deleteConfirm"
        persistent
        max-width="320"
        >
           <v-stepper v-model="e1">
                <v-stepper-header class="elevation-0">
                    <v-stepper-step
                        :complete="e1 > 1"
                        step="1"
                    >
                        Suppression
                    </v-stepper-step>

                    <v-divider></v-divider>

                    <v-stepper-step
                        :complete="e1 > 2"
                        step="2"
                    >
                        Abandon
                    </v-stepper-step>
                </v-stepper-header>

                <v-stepper-items>
                    <v-stepper-content step="1" class="pa-2 pb-4">
                        <v-card
                            elevation="0"
                        >
                            <v-card-title class="pt-0 " style="word-break: unset;">
                            Êtes-vous sûr de vouloir effacer le véhicule ?
                            </v-card-title>
                            <v-card-text>Ceci est une action irréversible.</v-card-text>
                        </v-card>
                        <v-btn text @click="cancelModal">
                        Annuler
                        </v-btn>
                        <v-btn
                        color="primary"
                        @click="e1 = 2"
                        >
                        Oui
                        </v-btn>
                    </v-stepper-content>

                    <v-stepper-content step="2" class="pa-2 pb-4">
                         <v-card
                            elevation="0"
                            v-if="!abandonLead"
                        >
                            <v-card-title class="pt-0 " style="word-break: unset;">
                            Voulez-vous abandonner le lead ?
                            </v-card-title>
                            <v-card-text>Ceci est une action irréversible.</v-card-text>
                        </v-card>

                        <v-card elevation="0"
                            v-if="abandonLead">
                            <v-card-title class="pt-0 pb-2" style="word-break: unset;">
                            Motif de l'abandon ?
                            </v-card-title>
                            <v-card-text>
                             <v-select v-model="abandonMotif" :items="abandonItems" label="Sélectionnez" hide-details></v-select>
                            </v-card-text>
                        </v-card>
                        
                        <v-btn text @click="deleteRdv" v-if="!abandonLead">
                        Non
                        </v-btn>
                        <v-btn
                        color="primary"
                        @click="abandonLead = true"
                        v-if="!abandonLead"
                        >
                        Oui
                        </v-btn>


                        <v-btn text @click="cancelModal" v-if="abandonLead">
                        Annuler
                        </v-btn>
                        <v-btn
                        color="primary"
                        @click="deleteRdv"
                        v-if="abandonLead"
                        >
                        Valider
                        </v-btn>
                    </v-stepper-content>

                </v-stepper-items>
            </v-stepper>
        </v-dialog>
    </div>
</template>
<script>
import Header from '@/components/Header'
import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat';
export default {
    name: 'AddRdv',
    props: ['code', 'idLead', 'mode'],
    components: {
        Header,
    },
    data() {
        return {
             menu: false,
            menu2: false,
            valid:false,
            deleteConfirm: false,
            rdvModal: false,
            abandonLead: false,
            selectors: true,
            abandonMotif:"",
            abandonItems: [
                "Véhicule souhaité non disponible", 
                "Changera dans plus d'un an", 
                "LLD/LOA trop récente", 
                "Déçu par la marque",
                "Déçu par le point de vente",
                "Pas le budget",
                "Concurrence",
                "Barrage secrétaire",
                "Déménagement",
                "Pas besoin véhicule",
                "Sénior",
                "Plus de permis",
                "Employé point de vente",
                "Voiture de fonction",
                "Pas disponible pendant l'opération"
            ],
            e1:1,
            projet: {},
            lead: {},
            dates: [],
            creneaux:[],
            rdv: {
                code_lead:"",
                jour:"", 
                creneau:"",
                id_utilisateur_externe: "",
                nb_pass: "",
                commentaire: "",
                est_venu: null,
                avec_vente: null,
                VO_VN_VD: null,
                financement:null,
                est_confirme: "OUI",
                est_physique: true
            },
            rdvRules: [
                (v) => !!v || 'La date et heure de rendez-vous est obligatoire',
                (v) => /^[0-3][0-9]\/[01][0-9]\/20[0-9]{2} [0-2][0-9]:[0-5][0-9]$/.test(v) || 'La date et heure ne sont pas valides'
            ],
        }
    },
    computed: {
        testDate: {
            get: function () {
                var jour = this.rdv.jour.split('/');
                return jour[2]+"-"+jour[1]+"-"+jour[0]
            },
            set: function (newValue) {
                var date = newValue.split('-')
                this.rdv.jour = date[2]+"/"+date[1]+"/"+date[0]
            }
        }
    },
    methods: {
        cancelModal(){
            this.e1 = 1;
            this.deleteConfirm = false; 
            this.abandonLead = false
        },
        reloadCreneaux(){
            this.creneaux = this.$store.getters.getCreneauxDispo(this.rdv.jour);
            let arrayDateHeure = this.lead.rdv[0].date_rendez_vous.split(" ");
            if(this.mode == "edit" && this.rdv.jour == arrayDateHeure[0]){
                const creneauxRdv = {
                    debut_creneau: this.$store.state.detailLead.rendez_vous[0].debut_creneau,
                    fin_creneau: this.$store.state.detailLead.rendez_vous[0].fin_creneau,
                    libelle: this.$store.state.detailLead.rendez_vous[0].libelle,
                    is_disponible: true,
                }
                this.creneaux.push(creneauxRdv);
            } 
            
        },
        recordRdv(){
            if(this.valid){
                this.$store.dispatch('setLoader', true).then((e) => {
                    this.$store.dispatch('addRdvToLead', this.rdv).then((e) => {
                        this.$store.dispatch('getLeadProjets', {codeProjet: this.code}).then((e) => {
                            this.$store.dispatch('getDetailLead', this.lead.code_lead).then(() => {
                                this.$router.push({ name: 'Details', params: { code: this.code, id: this.lead.id } })
                            })
                        })
                    })
                })
            }
            
            
        },
        modifyRdv(){
            if(this.valid){
                this.$store.dispatch('setLoader', true).then((e) => {
                    const payload = {
                        id_utilisateur: this.lead.id,
                        id_rendez_vous : this.lead.rdv[0].id,
                        data: {
                            code_lead: this.rdv.code_lead,
                            jour: this.rdv.jour,
                            creneau: this.rdv.creneau,
                            id_utilisateur_externe: this.rdv.id_utilisateur_externe,
                            nb_pass: this.rdv.nb_pass,
                            commentaire: this.rdv.commentaire,
                            est_confirme: "OUI"
                        }
                    }
                    if(this.rdv.est_venu == 0){
                        payload.data.est_venu = null
                    } else {
                        payload.data.est_venu = this.rdv.est_venu
                    }
                    if(this.rdv.avec_vente == 0){
                        payload.data.avec_vente = null
                    } else {
                        payload.data.est_venu = this.rdv.avec_vente
                    }
                    if(this.rdv.financement == 0){
                        payload.data.financement = null
                    } else {
                        payload.data.financement = this.rdv.financement
                    }
                    console.log("payload", payload);
                    this.$store.dispatch('updateRdv', payload).then((e) => {
                        this.$store.dispatch('getLeadProjets', {codeProjet: this.code}).then((e) => {
                            this.$store.dispatch('getDetailLead', this.lead.code_lead).then((e) => {
                                this.$router.push({ name: 'Details', params: { code: this.code, id: this.lead.id } })
                            })
                        })
                    })
                })
            }
        },
        deleteRdv(){
            let payload = "";
            if(this.abandonMotif != ""){
                payload = "?id_rendez_vous="+this.lead.rdv[0].id+"&id_utilisateur="+this.$store.state.user.id+"&avec_abandon='OUI'&motif_abandon="+this.abandonMotif
            } else {
                payload = "?id_rendez_vous="+this.lead.rdv[0].id+"&id_utilisateur="+this.$store.state.user.id
            }
            this.$store.dispatch('setLoader', true).then((e) => {
                this.$store.dispatch('deleteRdv', payload).then((e) => {
                    this.$store.dispatch('getLeadProjets', {codeProjet: this.code}).then((e) => {
                        this.$store.dispatch('getDetailLead', this.lead.code_lead).then((e) => {
                            this.$router.push({ name: 'Details', params: { code: this.code, id: this.lead.id } })
                        })
                    })
                })
            })
        }
    },
    created() {
        if(Object.keys(this.$store.state.leads).length === 0){
            this.$store.dispatch('setLoader', true).then((e) => {
                this.$store.dispatch('getLeadProjets', {codeProjet: this.code}).then((e)=> {
                    const lead = this.$store.state.leads.find(e => e.id == this.idLead);
                    this.$store.dispatch('getDetailLead', lead.code_lead).then((e) => {
                        this.$store.dispatch('getCreneauxVendeur', this.code).then((e) => {
                            this.lead = this.$store.state.leads.find(e => e.id == this.idLead);
                            this.rdv.code_lead = this.lead.code_lead;
                            this.dates = this.$store.getters.getDateDispo;
                            this.rdv.id_utilisateur_externe =  this.$store.state.user.id;
                            if(this.mode == "create"){
                                this.rdv.jour = this.dates[0];
                                this.creneaux = this.$store.getters.getCreneauxDispo(this.rdv.jour);
                            } else {
                                if(!this.lead.rdv[0].date_rendez_vous){
                                    this.rdv.jour = this.dates[0];
                                    this.creneaux = this.$store.getters.getCreneauxDispo(this.rdv.jour);
                                } else {
                                    let arrayDateHeure = this.lead.rdv[0].date_rendez_vous.split(" ");
                                    this.rdv.jour = arrayDateHeure[0];
                                    this.rdv.creneau = this.$store.state.detailLead.rendez_vous[0].debut_creneau;
                                    if(!this.dates.includes(arrayDateHeure[0])){
                                        this.selectors = false;
                                    } else {
                                        this.creneaux = this.$store.getters.getCreneauxDispo(arrayDateHeure[0]);
                                        const creneauxRdv = {
                                            debut_creneau: this.$store.state.detailLead.rendez_vous[0].debut_creneau,
                                            fin_creneau: this.$store.state.detailLead.rendez_vous[0].fin_creneau,
                                            libelle: this.$store.state.detailLead.rendez_vous[0].libelle,
                                            is_disponible: true,
                                        }    
                                        this.creneaux.push(creneauxRdv);
                                    } 
                                }
                                this.rdv.nb_pass = this.$store.state.detailLead.rendez_vous[0].pass;
                                this.rdv.commentaire = this.$store.state.detailLead.rendez_vous[0].commentaire;
                                this.rdv.est_venu = this.lead.rdv[0].venu;
                                this.rdv.avec_vente = this.lead.rdv[0].vendu;
                                this.rdv.VO_VN_VD = this.lead.rdv[0].type_vente;  
                                this.rdv.est_physique = this.lead.rdv[0].est_physique;   
                                this.rdv.financement = this.lead.rdv[0].financement;             
                            }
                            this.$store.dispatch('setLoader', false)
                        })
                        this.projet = this.$store.state.projets.find((e) => {
                            return e.code_projet == this.code
                        })
                    })
                })
            })
        } else {
            this.$store.dispatch('setLoader', true).then((e) => {
                this.$store.dispatch('getCreneauxVendeur', this.code).then((e) => {
                    this.lead = this.$store.state.leads.find(e => e.id == this.idLead);
                    this.rdv.code_lead = this.lead.code_lead;
                    this.dates = this.$store.getters.getDateDispo;
                    this.rdv.id_utilisateur_externe =  this.$store.state.user.id;
                    if(this.mode == "create"){
                        this.rdv.jour = this.dates[0];
                        this.creneaux = this.$store.getters.getCreneauxDispo(this.rdv.jour);
                    } else {
                        if(!this.lead.rdv[0].date_rendez_vous){
                            this.rdv.jour = this.dates[0];
                            this.creneaux = this.$store.getters.getCreneauxDispo(this.rdv.jour);
                        } else {
                            let arrayDateHeure = this.lead.rdv[0].date_rendez_vous.split(" ");
                            this.rdv.jour = arrayDateHeure[0];
                            this.rdv.creneau = this.$store.state.detailLead.rendez_vous[0].debut_creneau;
                            if(!this.dates.includes(arrayDateHeure[0])){
                                this.selectors = false;
                            } else {
                                this.creneaux = this.$store.getters.getCreneauxDispo(arrayDateHeure[0]);
                                const creneauxRdv = {
                                    debut_creneau: this.$store.state.detailLead.rendez_vous[0].debut_creneau,
                                    fin_creneau: this.$store.state.detailLead.rendez_vous[0].fin_creneau,
                                    libelle: this.$store.state.detailLead.rendez_vous[0].libelle,
                                    is_disponible: true,
                                }
                                this.creneaux.push(creneauxRdv);
                            }
                        }
                        this.rdv.nb_pass = this.$store.state.detailLead.rendez_vous[0].pass;
                        this.rdv.commentaire = this.$store.state.detailLead.rendez_vous[0].commentaire;
                        this.rdv.est_venu = this.lead.rdv[0].venu;
                        this.rdv.avec_vente = this.lead.rdv[0].vendu;
                        this.rdv.VO_VN_VD = this.lead.rdv[0].type_vente;    
                        this.rdv.est_physique = this.lead.rdv[0].est_physique;     
                        this.rdv.financement = this.lead.rdv[0].financement;      
                    }
                    this.$store.dispatch('setLoader', false)
                })
            })
            this.projet = this.$store.state.projets.find((e) => {
                return e.code_projet == this.code
            })
        }
    },
}
</script>
<style lang="scss">
    .rdvForm {
        padding-top:8vh;
        .btnGroup {
            display:flex;
            align-items:center;
            justify-content: space-between;
            &.btns{
                margin-top:20px;
            }
        }
    }
</style>